export const TOAST = {
  KIND: {
    DANGER: "danger",
    SUCCESS: "success",
    INFO: "primary",
  },
};